import { useTheme } from "../context/ThemeContext";

export default function StatCard({ label, value, note }) {
  const { mode } = useTheme();
  return (
    <div style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:8, padding:"16px 18px", flex:1, minWidth:0 }}>
      <div style={{ fontSize:11, color:"var(--text-dim)", textTransform:"uppercase", letterSpacing:"0.07em", fontWeight:600, marginBottom:10 }}>{label}</div>
      <div style={{ fontSize:28, fontWeight:700, color:"var(--ink)", fontVariantNumeric:"tabular-nums", lineHeight:1, letterSpacing:"-0.02em" }}>{value}</div>
      {note && <div style={{ fontSize:11, color:"var(--text-sub)", marginTop:5 }}>{note}</div>}
    </div>
  );
}
